module.exports = __webpack_public_path__ + "img/logorealtec.5dc382e4.svg";